import { formatURIComponent } from './utils'

export default (instance:string) => {

    const makeUrl = (path:string) => {
        return `/browser2?file_path=${formatURIComponent(path, instance)}&menu_key=budget&instance=${instance}`
    }

    return [{
        pageLayout: 'tabs',
        slogan: '华美服务 = 咨询服务 + 华美云 + 尽管问',
        pageTitle: '预算审核',
        pageTitleIcon: '',
        background_img: '/backgrounds/sunny.jpg',
        description: `在酒店预算审核服务中，许多业主和管理团队常常面临预算编制脱离运营实际、成本分摊不合理或绩效指标模糊等问题，导致资源错配或利润漏损。华美依托行业标杆数据和动态建模工具，深度分析历史经营数据与市场趋势，确保预算编制的科学性和前瞻性，为业主锁定可量化的财务提升空间。`,
        icons: [
            {
                name: '预算审核',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('/内容文件/华美/华美简介/8.预算审核.pdf'),
                path: "四库赋能-酒店资管/预算审核/成功案例"
            },
            {
                name: '华美项目',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('华美项目'),
                path: "四库赋能-酒店资管/预算审核/华美项目"
            },
            {
                name: '数据赋能',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店资管/预算审核/数据赋能'),
                path: "四库赋能-酒店资管/预算审核/数据赋能"
            },
            {
                name: '全球案例',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店资管/预算审核/全球案例/全球案例（预算审核）.xlsx'),
                path: "四库赋能-酒店资管/预算审核/全球案例"
            },
            {
                name: '预警问题',
                img: '/icons/工具库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店资管/预算审核/预警问题/预警问题（预算审核）.xlsx'),
                path: "四库赋能-酒店资管/预算审核/预警问题"
            },
        ]
    }]
}